import React from 'react';
import { InputAdornment as MuiInputAdornment } from '@mui/material';

const InputAdornment = props => <MuiInputAdornment {...props} />;

export default InputAdornment;
